export default {
  title: 'سبد خرید من',
  emptyCartTitle: 'سبد خرید شما خالی است!',
  emptyCartSub: 'هنوز هیچ محصول دوست‌داشتنی به سبد خریدت اضافه نکردی.',
  backToShop: 'دیدن محصولات و فروشگاه',
  unitPrice: 'قیمت واحد',
  quantity: 'تعداد',
  itemTotal: 'مجموع',
  summaryTitle: 'خلاصه سفارش',
  subtotal: 'جمع کل',
  tax: 'مالیات بر ارزش افزوده',
  shippingCost: 'هزینه ارسال',
  freeShipping: 'رایگان',
  discount: 'تخفیف',
  product: 'محصول',
  discountPaymentMethod: 'تخفیف روش پرداخت',

  totalDiscount: 'تخفیف کلی',
  payableAmount: 'مبلغ قابل پرداخت',
  toman: 'تومان',
  proceedToCheckout: 'تکمیل سفارش و پرداخت',
  clearCart: 'خالی کردن سبد خرید',
  stockLimit: 'حداکثر موجودی این محصول است',
  urls: {
    Product: '/product',
    Shop: '/products',
    Checkout: '/checkout',
    Shipping:"/fa/cart/shipping"
  }
}
